__turbopack_context__.v({
  "dot": "login_form-module__gk2Yxq__dot",
  "dotActive": "login_form-module__gk2Yxq__dotActive",
  "dots": "login_form-module__gk2Yxq__dots",
  "footer": "login_form-module__gk2Yxq__footer",
  "footerLink": "login_form-module__gk2Yxq__footerLink",
  "formInner": "login_form-module__gk2Yxq__formInner",
  "formSide": "login_form-module__gk2Yxq__formSide",
  "logo": "login_form-module__gk2Yxq__logo",
  "orange": "login_form-module__gk2Yxq__orange",
  "panel": "login_form-module__gk2Yxq__panel",
  "root": "login_form-module__gk2Yxq__root",
  "slide": "login_form-module__gk2Yxq__slide",
  "slideActive": "login_form-module__gk2Yxq__slideActive",
  "slideContent": "login_form-module__gk2Yxq__slideContent",
  "slideDecor": "login_form-module__gk2Yxq__slideDecor",
  "slideImage": "login_form-module__gk2Yxq__slideImage",
  "slideInactive": "login_form-module__gk2Yxq__slideInactive",
  "slideOverlay": "login_form-module__gk2Yxq__slideOverlay",
  "slideSubtitle": "login_form-module__gk2Yxq__slideSubtitle",
  "slideTitle": "login_form-module__gk2Yxq__slideTitle",
});
